import { render } from "./item.vue?vue&type=template&id=1ecff79d&scoped=true"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"

import "./item.vue?vue&type=style&index=0&id=1ecff79d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1ecff79d"

export default script